export default {
  methods: {
    showResponseError(err) {
      if (err?.response?.data?.notify) this.$store.dispatch('notify', err.response.data.notify);
      else if (err?.stack) {
        // strip "ErrorType: " prefix (e.g. "TypeError: ", "Error: ")
        this.$notify.danger(err.stack.split('\n', 1)[0].replace(/^[^:]+:\s*/, ''));
      }
    },
    showStzhResponseError(err) {
      if (!err.notify) return;
      const { notify } = err;
      const stzhToastbar = document.querySelector('stzh-toastbar');

      notify.forEach((n) => {
        stzhToastbar.toast(n.description, { type: 'error', duration: 3 });
      });
    },
  },
};
